import { App } from "./App";
import { cartService } from "../../../../shop/frontend/web/js/services/CartService";

window.CartService = cartService;
const app = new App();

app.init({
	CartService: window.CartService,
});
